export * from './accountPlanItems.service';
import { AccountPlanItemsService } from './accountPlanItems.service';
export * from './accounts.service';
import { AccountsService } from './accounts.service';
export * from './attachments.service';
import { AttachmentsService } from './attachments.service';
export * from './clients.service';
import { ClientsService } from './clients.service';
export * from './companyAccounts.service';
import { CompanyAccountsService } from './companyAccounts.service';
export * from './dashboards.service';
import { DashboardsService } from './dashboards.service';
export * from './dictionaries.service';
import { DictionariesService } from './dictionaries.service';
export * from './document.service';
import { DocumentService } from './document.service';
export * from './exchange.service';
import { ExchangeService } from './exchange.service';
export * from './mail.service';
import { MailService } from './mail.service';
export * from './profileSettings.service';
import { ProfileSettingsService } from './profileSettings.service';
export * from './security.service';
import { SecurityService } from './security.service';
export const APIS = [AccountPlanItemsService, AccountsService, AttachmentsService, ClientsService, CompanyAccountsService, DashboardsService, DictionariesService, DocumentService, ExchangeService, MailService, ProfileSettingsService, SecurityService];
